"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zonedDateTimeParts = zonedDateTimeParts;
exports.zonedWallDateTimeToDate = zonedWallDateTimeToDate;
function zonedDateTimeParts(date, timeZone) {
    const parts = new Intl.DateTimeFormat('en-US', {
        day: '2-digit',
        hour: '2-digit',
        hourCycle: 'h23',
        minute: '2-digit',
        month: '2-digit',
        second: '2-digit',
        timeZone,
        year: 'numeric',
    }).formatToParts(date);
    const byType = new Map(parts.map(part => [part.type, part.value]));
    return {
        day: numberPart(byType, 'day'),
        hour: numberPart(byType, 'hour'),
        millisecond: date.getUTCMilliseconds(),
        minute: numberPart(byType, 'minute'),
        month: numberPart(byType, 'month'),
        second: numberPart(byType, 'second'),
        year: numberPart(byType, 'year'),
    };
}
function numberPart(parts, type) {
    return Number.parseInt(parts.get(type) ?? '0', 10);
}
/**
 * The instant at which the given wall-clock time occurs in the timezone,
 * using the offset that applies on that day rather than today.
 */
function zonedWallDateTimeToDate(wall, timeZone) {
    const targetUtc = Date.UTC(wall.year, wall.month - 1, wall.day, wall.hour, wall.minute, wall.second, wall.millisecond);
    let guessUtc = targetUtc;
    for (let index = 0; index < 4; index += 1) {
        const actual = zonedDateTimeParts(new Date(guessUtc), timeZone);
        const actualUtc = Date.UTC(actual.year, actual.month - 1, actual.day, actual.hour, actual.minute, actual.second, actual.millisecond);
        const delta = targetUtc - actualUtc;
        if (delta === 0)
            break;
        guessUtc += delta;
    }
    return new Date(guessUtc);
}
